import { render } from "./SlidesItem.vue?vue&type=template&id=229bbb8d&scoped=true"
import script from "./SlidesItem.vue?vue&type=script&lang=js"
export * from "./SlidesItem.vue?vue&type=script&lang=js"

import "./SlidesItem.vue?vue&type=style&index=0&id=229bbb8d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229bbb8d"]])

export default __exports__